/**
 * @generated SignedSource<<f064d7f4cf6c37f1bd309a84d0fc0542>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CourseCategoryOrientation = "LANDSCAPE" | "PORTRAIT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type portals_coursePortal$data = {
  readonly active: boolean;
  readonly course: {
    readonly active: boolean;
    readonly category: {
      readonly active: boolean;
      readonly orientation: CourseCategoryOrientation;
    };
    readonly landscapeImage: {
      readonly signedUrl: string;
    } | null | undefined;
    readonly name: string;
    readonly portraitImage: {
      readonly signedUrl: string;
    } | null | undefined;
    readonly slug: string;
  };
  readonly id: string;
  readonly name: string;
  readonly section: {
    readonly active: boolean;
  };
  readonly slug: string;
  readonly " $fragmentType": "portals_coursePortal";
};
export type portals_coursePortal$key = {
  readonly " $data"?: portals_coursePortal$data;
  readonly " $fragmentSpreads": FragmentRefs<"portals_coursePortal">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "signedUrl",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "portals_coursePortal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "CourseSection",
      "kind": "LinkedField",
      "name": "section",
      "plural": false,
      "selections": [
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Course",
      "kind": "LinkedField",
      "name": "course",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageFile",
          "kind": "LinkedField",
          "name": "landscapeImage",
          "plural": false,
          "selections": (v3/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageFile",
          "kind": "LinkedField",
          "name": "portraitImage",
          "plural": false,
          "selections": (v3/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CourseCategory",
          "kind": "LinkedField",
          "name": "category",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "orientation",
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CourseClass",
  "abstractKey": "__isCourseClass"
};
})();

(node as any).hash = "9038d7e67f895da7c74aecd70e7877ae";

export default node;
